"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isApp = isApp;
exports.setIsApp = setIsApp;
exports.isQQ = exports.isWX = exports.device = exports.ENV = exports.getENV = void 0;
var hostname = window.location.hostname;
var userAgent = window.navigator.userAgent;
var openInApp = null; // 环境变量

var getENV = function getENV() {
  if (window.ENV === 'PROD' || window.ENV === 'DEV') {
    return window.ENV;
  } else if (/^(h5|s\w*)\.56qq\.([com]||[cn])/.test(hostname)) {
    return 'PROD';
  }

  return 'DEV';
};

exports.getENV = getENV;
var ENV = getENV(); // 设备类型

exports.ENV = ENV;

var device = function () {
  if (/Android/i.test(userAgent)) {
    return 'android';
  } else if (/iPhone|iPod|iPad/i.test(userAgent)) {
    return 'ios';
  }

  return false;
}(); // 是否是在App内


exports.device = device;

function isApp() {
  // console.log(userAgent);
  if (openInApp !== null) {
    return openInApp;
  }

  if (/Truck Alliance/i.test(userAgent) || window.WLAuth) {
    return true;
  }

  return false;
} // 手动设置是否在app内


function setIsApp(value) {
  openInApp = value;
} // 是否在微信内


var isWX = function () {
  return /MicroMessenger/i.test(userAgent) && !isApp();
}(); // 是否在QQ内


exports.isWX = isWX;

var isQQ = function () {
  return /qq/i.test(userAgent) && !isWX && !isApp();
}();

exports.isQQ = isQQ;